import React, { useState, useEffect, useRef } from 'react';

const requestMethods = [
  { slug: 'get', method: 'GET', color: 'text-green-600' },
  { slug: 'post', method: 'POST', color: 'text-blue-600' },
  { slug: 'put', method: 'PUT', color: 'text-orange-600' },
  { slug: 'patch', method: 'PATCH', color: 'text-purple-600' },
  { slug: 'delete', method: 'DELETE', color: 'text-red-600' },
];

export default function UrlEditor({
  url,
  setUrl,
  reqMethod,
  setReqMethod,
  onInputSend,
  loading,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const currentMethod = requestMethods.find(m => m.method === reqMethod);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <form className='flex gap-3 w-full'>
      <div className='relative flex-shrink-0' ref={dropdownRef}>
        <button
          type='button'
          onClick={() => setIsOpen(!isOpen)}
          className={`px-4 py-3 text-sm font-bold rounded-lg border-2 border-gray-200 hover:border-[#fdb814] focus:outline-none focus:ring-2 focus:ring-[#fdb814]/20 bg-white transition-all duration-200 flex items-center gap-2 min-w-[110px] shadow-sm ${currentMethod.color}`}
        >
          {reqMethod}
          <svg className={`w-4 h-4 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} fill='none' stroke='currentColor' viewBox='0 0 24 24'>
            <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M19 9l-7 7-7-7' />
          </svg>
        </button>
        {isOpen && (
          <div className='absolute top-full mt-2 w-full bg-white border border-gray-200 rounded-lg shadow-xl z-50'>
            {requestMethods.map((option) => (
              <button
                key={option.slug}
                type='button'
                onClick={() => {
                  setReqMethod(option.method);
                  setIsOpen(false);
                }}
                className={`w-full px-4 py-2.5 text-sm font-bold text-left hover:bg-gray-50 transition-all duration-150 first:rounded-t-lg last:rounded-b-lg ${option.color}`}
              >
                {option.method}
              </button>
            ))}
          </div>
        )}
      </div>
      <input
        className='flex-1 px-4 py-3 text-sm border-2 rounded-lg border-gray-200 hover:border-[#fdb814] focus:outline-none focus:ring-2 focus:ring-[#fdb814]/20 transition-all duration-200 shadow-sm'
        value={url}
        onChange={(e) => setUrl(e.target.value)}
        placeholder='Enter request URL (e.g., https://api.example.com/endpoint)'
      />
      <button
        className='px-8 py-3 text-sm rounded-lg font-bold text-white bg-gradient-to-r from-[#fdb814] to-[#e5a50f] hover:from-[#e5a50f] hover:to-[#d4940a] disabled:from-gray-300 disabled:to-gray-400 disabled:cursor-not-allowed transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105 active:scale-95 focus:outline-none focus:ring-4 focus:ring-[#fdb814]/30 flex-shrink-0'
        type='button'
        onClick={(e) => onInputSend(e)}
        disabled={loading}
      >
        {loading ? (
          <svg className='animate-spin h-5 w-5 mx-auto' fill='none' viewBox='0 0 24 24'>
            <circle className='opacity-25' cx='12' cy='12' r='10' stroke='currentColor' strokeWidth='4'></circle>
            <path className='opacity-75' fill='currentColor' d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'></path>
          </svg>
        ) : 'Send'}
      </button>
    </form>
  );
}
